<template>
  <div>
    <mall-header ></mall-header>
    <div class="guide-content" ></div>
    <div class="statisticsList-header" >
    <nav-Menu></nav-Menu>
    <div  class=" statisticsList-div" >
        <div>
          <span class="statisticsList-div-span" >使用统计</span>
          <span  class="statisticsList-div-span1"  @click="openDetails" v-if="statisticsList.length">查看使用明细</span>
          <span class="statisticsList-div-line" ></span>
        </div>
           <div>
              <el-table :data="statisticsList" :row-style="{height:'45px',color:'#333'}" v-loading="fullscreenLoading" :cell-style="{'padding-top': '7px','padding-bottom': '7px'}"
                  class="statisticsList-table" style="" :header-cell-style="{height:'40px',background: '#F6F6F6',color:'#666','font-size': '14px','font-family': 'PingFang SC','font-weight': '500'}">
                  <el-table-column prop="serviceClassName" class="statisticsList-table-column"  label="服务分类" width="180"></el-table-column>
                  <el-table-column  style="height: 40px;" label="服务项目" width="220">
                      <template slot-scope="scope">
                        <el-tooltip placement="right"  :open-delay="500"  :disabled="nameTips" :content='scope.row.serviceItemName' >
                              <span   class="statisticsList-table-button" @mouseenter="nameTipsFun($event)" @click="serverClick(scope.row)">{{scope.row.serviceItemName}}</span>
                          </el-tooltip>
                      </template>
                  </el-table-column>
                  <el-table-column  prop="serviceItemUnit" style="height: 40px;" width="100" label="单位" align="center"> </el-table-column>
                  <el-table-column  prop="totalAmount" style="height: 40px;" label="购买数量" align="center" width="150"> </el-table-column>
                  <el-table-column prop="usedAmount" style="height: 40px;" label="已使用数量" align="center" width="150"></el-table-column>
                  <el-table-column prop="remainAmount"  style="height: 40px; " label="剩余数量" align="center" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.remainAmount>0" style="color: #333333;">{{scope.row.remainAmount}}</span>
                        <span v-if="scope.row.remainAmount<=0" style="color:#FF620D">{{scope.row.remainAmount}}</span>
                      </template>
                  </el-table-column>
                  <template slot="empty">
                        <div  style="   margin-top: 100px;">
                          <img src="../../static/images/空.png" alt="" >
                          <p  class="invoiceList-defut-font">哎呀，什么都没有 T_T</p>
                        </div>
                  </template>
              </el-table>
            </div>
             <div v-if="statisticsList.length>0" id="orderAllPage">
                  <el-pagination background
                    style="margin-top: 20px; float: right;margin-right: 30px;    margin-bottom: 20px;"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="querydata.pageNo"
                      :page-sizes="[10,  20, 40]"
                      :page-size="querydata.pageSize"
                      layout="total, sizes, prev, pager, next"
                      :total="statisticsTotal">
                  </el-pagination>
            </div>
            <el-backtop  :bottom="100" style="right: auto;" >
            <div
              style="
                height: 100%;
                width: 100%;
                box-shadow: 0 0 6px rgba(0,0,0, .12);
                text-align: center;
                line-height: 40px;
                color: #1989fa; ">
              <img src="../../static/images/backtop.png" style="      margin-top: 15px;width: 20px;height: 20px;"/>
            </div>
          </el-backtop>
      </div>
    </div>
     <mall-footer ></mall-footer>
  </div>
</template>
<script>
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import navMenu from '../components/navMenu.vue'
import axios from 'axios'
import http from '../api/public'
  export default {
    data () {
      return {
        statisticsList:[],
        mdShow:false,
        payShow:true,
        selectType:0,
        payC:false,
        nameTips:true,
        activeName: 'first',
        statisticsTotal:0,
        fullscreenLoading:true,
        orId:'',
         querydata:{
          pageNo:1,//初始显示第几页
          pageSize:10//每页显示多少数据
        },
      }
    },
    mounted() {
      //使用统计列表数据获取
      this.getOrderData();
      //this.ComputetTime();
      //this.fullscreenLoading=false;
    },
    methods: {
      //使用统计列表数据获取
      getOrderData() {
        axios.get('/mallApi/mall/index/queryCompanyServiceClass',{params:this.querydata ,headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
          res = res.data;
          if(res.success ) {
              this.statisticsList = res.result.records;
              this.statisticsTotal = res.result.total;
          }else{
            if(res.code == 401 || res.code == 400) {
                http.setLocalStorge();
                this.$router.push({path: '/login'});
              }else{

                  this.$message({
                      showClose: true,
                      message: '操作失败！',
                      type: 'error'
                    });
              }
          }
          this.fullscreenLoading=false;
        });
      },
      //使用统计详情数据获取
      openDetails(){
           this.$router.push({path: '/statisticsDetails'})
           //window.open("#/statisticsDetails");
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }, //分页当前页change 事件
      handleCurrentChange(currentPage){
        this.querydata.pageNo = currentPage;

        this.getInvoiceData();
      },
      //分页当前条数 change 事件
      handleSizeChange(pagesize){
        console.log(pagesize)
        this.querydata.pageSize = pagesize;
        //this.form.size = val;
        this.getInvoiceData();

      },
      //点击图标或名字进入商品详情
      serverClick(row){
       // debugger
         window.open("#/GoodsDetails?id="+row.serviceItemId);
        console.log(row);
      },
      nameTipsFun(obj){
        //debugger
        let cWidth = obj.target.offsetWidth;
         // let  sWidth = obj.currentTarget.scrollWidth;
        cWidth > 186? this.nameTips = false : this.nameTips = true;
      }
    },
    components: {
      mallHeader,
      mallFooter,
      mallBread,
      navMenu,
      http
    }
  }
</script>
<style  >
  .el-table::before {
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 0px;
}

.el-table td{
    border-bottom: 1px solid #EEEEEE!important;
}
.el-table th.is-leaf {
  border-bottom: 0px solid #EEEEEE!important;
}
.statisticsList-header{
  overflow-x: auto; min-width: 1200px;    width: 1200px;margin: 0 auto;
}
.statisticsList-div div.el-table__empty-block {
    text-align: center;
    width: 100%;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    margin-bottom: 225px !important;
}
 .statisticsList-div   div.el-backtop {
    margin-left: 1000px ;
    bottom: 50px ;
    width: 50px ;
    height: 50px ;
    opacity: 0.1;
    border-radius: 25px ;
    background: rgb(0, 0, 0) ;
}

.statisticsDetails-div div.el-table::before {
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 0px!important;
}
  .statisticsList-div{
        width: 980px;
    min-width: 980px;
    margin-bottom: 60px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    overflow: auto;
    margin: 0 auto;
    float: left;
    margin-top: -360px;
    margin-left: 220px;
    min-height: 480px;
  }
  .statisticsList-div div
  .statisticsList-div-min{
      margin-left: 520px;width: 51%;
      height: 518px;
      background: #FFFFFF;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);    margin-top: -360px;
  }
  .statisticsList-div-span{
         height: 16px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    float: left;
    margin-left: 30px;
    margin-top: 20px;
  }
  .statisticsList-div-span1{
       float: right;
          margin-right: 30px;
          margin-top: 20px;
          height: 14px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #287EFF;
          cursor: pointer;
          line-height: 20px;
  }
  .statisticsList-div-span1:hover{text-decoration: underline;border-bottom:2px; color:#287EFF solid;}
  .statisticsList-div-line{
        width: 980px;
          border-bottom: 1px solid #EEEEEE;
          height: 1px;
          position: absolute;
          margin-top: 60px;
          margin-left: -95px
  }
  .statisticsList-table{
    height: auto;
    margin: 45px 30px 20px 30px;
    float: left;
    width: 920px;

  }
  .statisticsList-table-button{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #287EFF;
    line-height: 0px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
  }
  .statisticsList-table-button:hover{text-decoration: underline;border-bottom:2px; color:#287EFF solid;}

.statisticsList-table-column{
    height: 40px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #287EFF;
    line-height: 45px;
    cursor: pointer;
}

.statisticsList-div-p{
   margin-top: -115px;
    margin-left: 420px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 45px;
}

.el-table .cell {
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    line-height: 23px;
    padding-right: 10px;
    /*height: 20px !important;*/
}


</style>



// WEBPACK FOOTER //
// StatisticsList.vue?3365e0ec